const providers = (state = [], action) => {
    switch (action.type) {
      case 'UPDATE_PROVIDERS':
        return action.providers || [];
      default:
        return state;
    }
  };
  export default providers;
  